/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { current } from 'store/slices/auth';

export const useCurrentUser = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(current());

    // refresh every 59 minutes
    const interval = setInterval(
      () => {
        dispatch(current());
      },
      59 * 60 * 1000
    );

    return () => clearInterval(interval);
  }, [dispatch]);
};
